import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarService } from "../services/snackbar.service";

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackbarService = inject(SnackbarService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = "Ha ocurrido un error inesperado";

      if (error.status >= 400) {
        switch (error.status) {
          case 400:
            errorMessage =
              error.error?.errortxt ||
              error.error?.message ||
              error.error?.error ||
              "Solicitud incorrecta";
            break;
          case 401:
            errorMessage =
              error.error?.errortxt ||
              error.error?.error ||
              error.error?.message ||
              "No autorizado. Por favor, inicie sesión nuevamente";
            break;
          case 403:
            errorMessage =
              error.error?.errortxt ||
              error.error?.message ||
              error.error?.error ||
              "No tiene permisos para realizar esta acción";
            break;
          case 404:
            errorMessage =
              error.error?.errortxt ||
              error.error?.message ||
              error.error?.error ||
              "Recurso no encontrado";
            break;
          case 409:
            errorMessage =
              error.error?.errortxt ||
              error.error?.message ||
              error.error?.error ||
              "Conflicto en la operación";
            break;
          case 422:
            errorMessage =
              error.error?.errortxt ||
              error.error?.message ||
              error.error?.error ||
              "Datos de entrada inválidos";
            break;
          case 500:
            errorMessage =
              error.error?.errortxt ||
              error.error?.message ||
              error.error?.error ||
              "Error interno del servidor";
            break;
          case 502:
            errorMessage =
              error.error?.errortxt ||
              error.error?.message ||
              error.error?.error ||
              "Servicio no disponible temporalmente";
            break;
          case 503:
            errorMessage =
              error.error?.errortxt ||
              error.error?.message ||
              error.error?.error ||
              "Servicio no disponible";
            break;
          case 555:
            errorMessage = `${error.error?.message || "Ha ocurrido un error inesperado"}`;
            break;
          default:
            errorMessage = `${error.error?.message || "Ha ocurrido un error inesperado"}`;
        }

        snackbarService.error(errorMessage);
      }

      return throwError(() => error);
    })
  );
};
